import './styles/SmallAiButton.scss';

import { Tooltip } from '@whistler-ui/k2/components/Tooltip';
import { cn } from '@whistler-ui/k2/helpers/classBuilders';

import { BridgeKeeper } from '../../../../components/BridgeKeeper/BridgeKeeper';

const buildAnalysisPrompt = (correlationId?: string) => {
  const correlationRef = correlationId
    ? ` (correlation id ${correlationId})`
    : '';

  return `Give me details about this case${correlationRef}. Look up the relevant logs and explain what happened and the likely cause.`;
};

export const SmallAiButton = ({
  onClick,
  correlationId,
}: {
  onClick: (message: string) => void;
  /** Correlation id of this specific API call — the assistant looks the case up itself. */
  correlationId?: string;
}) => {
  return (
    <BridgeKeeper
      feature="ai_device_log_analysis"
      withLoader={false}
      fallbackComponent={null}
    >
      <div className="flex flex-col justify-center gap-0">
        <Tooltip
          align="left"
          content="Analyze with AI"
          trigger={
            <button
              type="button"
              data-dd-action-name="ai_analysis_from_small_button_clicked"
              className={cn(
                'c-AiAnalyzerButton',
                'flex',
                'w-[24px]',
                'h-[24px]',
                'font-medium',
                'text-white',
                'rounded-sm',
                {
                  disabled: !onClick,
                },
              )}
              disabled={!onClick}
              data-testid="n-ai-analyze-button"
              onClick={() => onClick(buildAnalysisPrompt(correlationId))}
            >
              <svg
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="15"
                viewBox="0 0 20 19"
                fill="none"
                className="mx-auto my-auto"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.47975 9.47975L7.50012 4.84192L9.52032 9.47975L14.2297 11.5001L9.52032 13.5203L7.50012 18.5001L5.47975 13.5203L0.841919 11.5001L5.47975 9.47975Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.2297 3.22975L15.5001 0.841919L16.7703 3.22975L19.1581 4.50012L16.7703 5.77032L15.5001 8.15815L14.2297 5.77032L11.8419 4.50012L14.2297 3.22975Z"
                  fill="white"
                />
              </svg>
            </button>
          }
        />
      </div>
    </BridgeKeeper>
  );
};
